export default {
  title: 'Messages',
  empty: { title: 'Aucune conversation pour le moment.', description: 'Écrivez-nous pour toute question sur vos ménages.' },
  noSubject: 'Sans objet',
  unassigned: 'Non assignée',
  priorityHigh: 'Prioritaire',
  you: 'Vous',
  team: 'L’équipe',
  internalNote: 'Note interne',
  reply: 'Réponse',
  composerMode: 'Type de message',
  placeholder: 'Écrire un message…',
  notePlaceholder: 'Note visible seulement par l’équipe (ex. : @Sophie vérifier le prix)',
  noteHint: 'Les notes internes ne sont jamais visibles par le client ou l’employé.',
  send: 'Envoyer',
  read: 'Lu',
  sent: 'Envoyé',
  statusChanged: 'Statut : {{status}}',
  newConversation: 'Nouveau message',
  subject: 'Objet',
  message: 'Message',
  start: 'Envoyer le message',
  back: 'Toutes les conversations',
};
